// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"90805a39","242":"eee6f5f2","277":"ca0f9908","461":"03de1ece","532":"76caf2ce","546":"73b367a7","736":"71a9fc4d"}[chunkId] + ".chunk.js";
};